/*
 * @Author: hucaili hucaili@qfei.cn
 * @Date: 2023-05-23 16:18:30
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2025-07-14 18:27:44
 * @FilePath: /fe-crm/src/api/fields-service.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BaseService } from './base-service';
class FieldsService extends BaseService {
  /**
   * @description: 获取全局字段列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getFieldList(data) {
    return this.request({
      method: 'get',
      url: `/global_field/list`,
      params: data
    });
  }
  /**
   * @description: 新增全局字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  addGlobalField(data) {
    return this.request({
      method: 'post',
      url: `/global_field/add`,
      data
    });
  }
  /**
   * @description: 修改全局字段
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateGlobalField(data) {
    return this.request({
      method: 'post',
      url: `/global_field/update`,
      data
    });
  }
  /**
   * @description: 修改停启用状态
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateFieldIsEnabled(data) {
    return this.request({
      method: 'post',
      url: `/global_field/change/isEnabled`,
      data
    });
  }
  /**
   * @description: 字段名称判重
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  verifyName(data) {
    return this.request({
      method: 'post',
      url: `/global_field/verify_name`,
      data
    });
  }
  /**
   * @description: 全局字段详情
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getDetail(data) {
    return this.request({
      method: 'get',
      url: `/global_field/detail`,
      params: data
    });
  }
  /**
   * @description: 获取子表单字段个数
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getCountSubField(data) {
    return this.request({
      method: 'get',
      url: `/sys-entity/children/form/sum`,
      params: data
    });
  }

  /**
   * @brief 获取某个对象中的某个字段的值
   * @params entity 对象标识
   * @params fieldKey 字段key
   * @params businessId 业务数据id
   */
  getFieldValueByEntity(params) {
    return this.request({
      method: 'GET',
      url: `/single/field/findMultiple`,
      params
    });
  }
}

export const fieldsService = new FieldsService();
